module.exports = __webpack_public_path__ + "static/media/fill_62@3x.d1a7b72c.png";